<template>
  <v-container>
    <div class="text-center">
      <v-overlay :value="showLoadingDialog" class="flex-column">
        <p>{{ loadingDialogMessage }}</p>
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      showLoadingDialog: 'dialogModule/getShowLoadingDialog',
      loadingDialogMessage: 'dialogModule/getLoadingDialogMessage',
    }),
  },
}
</script>
